export enum GenericTableFilterTypes {
    Text = 'Text',
    DateTime = 'DateTime',
    Date = 'Date',
    Boolean = 'Boolean',
    Status = 'Status',
    Select = 'Select',
    MultiSelect = 'MultiSelect',
    Importance = 'Importance'
}

export enum GenericTableColumTypes {
    Text = 'Text',
    Text_ = 'Text_',
    DateTime = 'DateTime',
    Date = 'Date',
    Boolean = 'Boolean',
    Status = 'Status',
    Image = 'Image',
    Link = 'Link',
    Contact = 'Contact',
    Actions = 'Actions',
    Importance = 'Importance',
    Template = 'Template',
    HTML = 'HTML',
    SETTINGS = 'Settings',
}